import {combineReducers} from "redux";

import fileManagementViewModel from "./fileManagementViewModel";
import fileDetailViewModel from "./fileDetailViewModel";
import personnelManagementViewModel from "./personnelManagementViewModel";
import awardViewModel from "./awardViewModel";
import pregnancyDueDateViewModel from "./pregnancyDueDateViewModel";
import staffInfoViewModel from "./staffInfoViewModel";
import stats from "./stats/index";
import rotationViewModel from "./rotationViewModel";
import annualAttendanceViewModel from "./annualAttendanceViewModel";
import trainViewModel from "./trainViewModel";
import employeeLoanViewModel from "./employeeLoanViewModel";
import trainHourCreditViewModel from "./trainHourCreditViewModel";
import misconductDeductViewModel from "./misconductDeductViewModel";

const rootViewModel = combineReducers({
    fileManagementViewModel,
    fileDetailViewModel,
    personnelManagementViewModel,
    employeeLoanViewModel,
    awardViewModel,
    pregnancyDueDateViewModel,
    staffInfoViewModel,
    rotationViewModel,
    annualAttendanceViewModel,
    trainViewModel,
    trainHourCreditViewModel,
    stats,
    misconductDeductViewModel,
});

export default rootViewModel;
